import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { AdjustmentRuleAction } from '@cbridge-packages/adjustment-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onUpdateAdjustmentRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    AdjustmentRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      RulesManagementAction.endEditing(undefined),
    ];
  }),
);
